import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Packages from "../components/Packages";
import MyPackage from "../components/MyPackage";
import Footer from "../components/Footer";
import Analytics from "../components/GoogleAnalytics";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheckCircle,
    faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import Navbar from "../components/Navbar";
import { Form, FormControl, Modal } from "react-bootstrap";

const OurPackages = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState({});
    const [error, setError] = useState({});

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSelectPackage = (pkg) => {
        // setSelectedPackage(pkg);
        navigate("/payment-method", { state: { selectedPackage: pkg } });
    };

    useEffect(() => {
        const sessionUser = JSON.parse(sessionStorage.getItem("user"));
        if (sessionUser && sessionUser.payLoad.access_token) {
            // setSession(sessionUser.payLoad.user);
        }
    }, []);

    const packages = [
        {
            id: 1123,
            title: "One Time Instant Doctors",
            location: "Pakistan",
            originalPrice: "Rs. 1500",
            discountedPrice: "Rs. 300 only",
            discount: "80% Off",
            features: [
                { text: "Video Call to Doctor", isAvailable: true },
                { text: "Instant Prescription via SMS and App", isAvailable: true },
                { text: "One-time Payment", isAvailable: true },
                { text: "Unlimited Video Calls", isAvailable: false },
                { text: "Maintains Full Medical History", isAvailable: false },
            ],
        },
        {
            id: 1124,
            title: "WEBDOC Instant Doctors",
            description: "(Unlimited Calls)",
            originalPrice: "Rs. 4000",
            discountedPrice: "Rs. 999/- only",
            discount: "75% Off",
            features: [
                { text: "Video Call to Doctor Anytime", isAvailable: true },
                { text: "Maintains Full Medical History", isAvailable: true },
                { text: "Instant Prescription via SMS and App", isAvailable: true },
                { text: "Monthly Subscription", isAvailable: true },
                { text: "Unlimited Video Calls", isAvailable: true },
            ],
        },
        {
            id: 1126,
            title: "One Time Instant Doctors for Expats",
            originalPrice: "$25 per call",
            discountedPrice: "$10 per call",
            discount: "60% Off",
            features: [
                { text: "Video Call to Doctor", isAvailable: true },
                { text: "Instant Prescription via SMS and App", isAvailable: true },
                { text: "One-time Payment", isAvailable: true },
                { text: "Unlimited Video Calls", isAvailable: false },
                { text: "Maintains Full Medical History", isAvailable: false },
            ],
        },
        {
            id: 1125,
            title: "WEBDOC Instant Doctors",
            description: "(Unlimited Calls) for Expats",
            originalPrice: "$35 a month",
            discountedPrice: "$14 monthly",
            discount: "60% Off",
            features: [
                { text: "Video Call to Doctor anytime", isAvailable: true },
                { text: "Maintains Full Medical History", isAvailable: true },
                { text: "Instant Prescription via SMS and App", isAvailable: true },
                { text: "Monthly Subscription", isAvailable: true },
                { text: "Unlimited Video Calls", isAvailable: true },
            ],
        },
    ];

    // Check if isSession is not null and if userPackages is defined
    return (
        <div>
            <Navbar />
            {packages && packages.length > 0 ? (
                packages.map((pkg) => (
                    <div
                        key={pkg.id}
                        className="newPackage-card col-md-6 col-sm-12 text-center"
                        style={{ minWidth: 320, flex: "0 0 auto", margin: "20px auto" }}
                    >
                        {" "}
                        {pkg.recommended && (
                            <div className="recommended-ribbon">Recommended</div>
                        )}
                        {pkg.insurance && (
                            <div className="insurance-ribbon">
                                <span>FREE Health Insurance</span>
                            </div>
                        )}
                        <div className="ribbon">
                            <span>{pkg.discount}</span>
                        </div>
                        <div style={{ height: 370 }}>
                            <div >
                                <div
                                    className="d-flex justify-content-center align-items-center"
                                    style={{
                                        marginTop: "30px",
                                        fontWeight: 1200,
                                        fontSize: "25px",
                                    }}
                                >
                                    <span style={{ color: "#000", fontWeight: 900 }}>
                                        WEB
                                    </span>
                                    <span
                                        style={{
                                            color: "#3ec3cf",
                                            fontWeight: 900,
                                            marginLeft: "2px",
                                        }}
                                    >
                                        DOC
                                    </span>
                                    <span
                                        style={{
                                            color: "#444",
                                            fontWeight: 600,
                                            marginLeft: "8px",
                                        }}
                                    >
                                        CARE
                                    </span>
                                    <span
                                        style={{
                                            fontWeight: 600,
                                            marginLeft: "2px",
                                        }}
                                    >
                                        +
                                    </span>
                                </div>
                                <p className="package-title">{pkg.title}</p>
                            </div>

                            <div
                                className="price"
                                style={{ position: "relative", display: "inline-block" }}
                            >
                                <div
                                    className="original-price"
                                    style={{
                                        color: "#000",
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        position: "relative",
                                        zIndex: 1,
                                        color: "#DC0316",
                                    }}
                                >
                                    {pkg.originalPrice}
                                </div>
                                <span className="discounted-price fs-5">
                                    {pkg.discountedPrice}
                                </span>
                            </div>
                            <div className="">
                                {pkg.description && <p></p>}
                                <ul className="features-list h-50">
                                    {pkg.features.map((feature, i) => (
                                        <li key={i} className="feature-item mb-3">
                                            <FontAwesomeIcon
                                                icon={
                                                    feature.isAvailable
                                                        ? faCheckCircle
                                                        : faTimesCircle
                                                }
                                                className={`feature-icon ${feature.isAvailable ? "" : "feature-icon-cross"
                                                    }`}
                                            />{" "}
                                            {feature.text}
                                            {feature.link && (
                                                <a
                                                    href="/doc/termsAndCondition.docx"
                                                    target="_blank"
                                                    className="feature-link"
                                                >
                                                    - Terms & Conditions Apply
                                                </a>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <FormControl
                            type="number"
                            placeholder=" Phone Number"
                            className="subscribeInput"
                        />
                        <div className="d-flex justify-content-start mb-1">
                            <a
                                target="_blank"
                                className="feature-link text-decoration-none text-start"
                            >
                                Terms & Conditions Apply
                            </a>
                        </div>
                        <button
                            className="subscribeCardBtn w-100"
                            // onClick={() => handleConfirmPayment(pkg)}
                            onClick={handleShow}
                            disabled={loading[pkg.id]}
                        >
                            Subscribe
                        </button>
                        {error[pkg.id] && (
                            <p className="error-message">{error[pkg.id]}</p>
                        )}
                    </div>
                ))
            ) : (
                <p></p>
            )}
            <div style={{ marginTop: "100px" }}>
                <Footer />
            </div>
            <Modal show={show} onHide={handleClose} centered size="sm">
                <Modal.Body>
                    <ol className="mb-0">
                        <li>Login to Easypaisa App</li>
                        <li>Navigate to My Approvals</li>
                        <li>Approve the Voucher</li>
                    </ol>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default OurPackages;
